import { RouteConfig } from 'vue-router'

import {
	WorkSheetsMonthlyIndex,
  PayrollMonthly
} from '@/views'

const workSheetMonthlyRouter: Array<RouteConfig> = [
	{
    path: 'work-sheets-monthly',
    name: 'work-sheets-monthly',
    component: WorkSheetsMonthlyIndex,
    meta: {
      requiresVisitor: false,
      requiresAuth: true,
      title: 'Planilla Mensual'
    }
  },
  {
    path: 'payroll-monthly/:year/:month',
    name: 'payroll-monthly',
    component: PayrollMonthly,
    meta: {
      requiresVisitor: false,
      requiresAuth: true,
      title: 'Planilla Mensual | Generar'
    }
  }
]

export default workSheetMonthlyRouter
